import { render, staticRenderFns } from "./UserListCard.vue?vue&type=template&id=590f2404&"
import script from "./UserListCard.vue?vue&type=script&lang=js&"
export * from "./UserListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports